export class RestApiError extends Error {
    httpCode: number;
    constructor(message, httpCode: number) {
        super(message);
        this.httpCode = httpCode;

        Object.setPrototypeOf(this, RestApiError.prototype);
    }
}
